import { addCursor, setStyles } from "./chunks";
import contextMode, { contextModeDestroy } from "./modes/contextMode";
import propNames from "./propNames";

const contextCursor = (props = {}, destroy) => {
  // Default props
  props = {
    radius: props.radius || 20,
    transitionSpeed: props.transitionSpeed || 0.2,
    parallaxIndex: props.parallaxIndex || 10,
    hoverPadding: props.hoverPadding || 6,
  };

  if (destroy) {
    console.log("destroying...");

    if (document.querySelector(".c-cursor")) {
      document.querySelector(".c-cursor").remove();
    }
    contextModeDestroy(null, props, [...document.querySelectorAll(`[${propNames.dataAttr}]`)]);
    return;
  }

  console.log('initializiing...')

   // Set base
   setStyles();
   const cCursor = addCursor(props);

   if (document.readyState === 'complete') {
    let interactElements = document.querySelectorAll(
      `[${propNames.dataAttr}]`
    );

    console.log(cCursor)
    console.log("interactElements", interactElements);
    contextMode(cCursor, props, interactElements);
    return;
   }

  // Load mode when page is loaded
  window.onload = () => {
    let interactElements = document.querySelectorAll(
      `[${propNames.dataAttr}]`
    );

    console.log(cCursor)
    console.log("interactElements", interactElements);
    contextMode(cCursor, props, interactElements);
  };
};

export default contextCursor;
